import { InteractiveElementsList } from "../interactive-elements-list/InteractiveElementsList";

export function findFirstInteractiveElement(container: HTMLElement): HTMLElement | null {
    const interactiveElementsList = new InteractiveElementsList(container);
    return interactiveElementsList.first();
}
